<template>
  <div class="nav fl">
    <!-- 项目id: {{ pid }} -->
    <!-- {{ JSON.stringify(project) }} -->
    <ul v-if="menuList && menuList.length">
      <template v-for="item in menuList">
        <li
          v-if="item.show"
          :ref="item.group"
          :key="item.key"
          :class="setClass(item)"
        >
          <div
            class="item clearfix"
            @click="handleChangeMenu(item, $event)"
          >
            <i
              class="iconfont left-icon"
              :class="`${item.iconClass}`"
            />
            <template>
              <!-- <template v-if="item.name==='万能表单'">
                <template>
                  <em class="universal-tit-box">
                    <span class="name">{{ item.name }}</span>
                    <i class="new-ico" />
                  </em>
                </template>
                <div
                  v-if="!cookie || cookie!== $store.state.auth"
                  class="tip-dialog"
                >
                  <i class="ioc-arrow" />
                  <i
                    class="close iconfont iconicon-test5"
                    @click.stop="setCookie"
                  />
                  <p>支持将自有站点的表单数据直接提交到星轨询盘管理</p>
                  <a
                    href="javascript:;"
                    @click.stop="setCookieTo"
                  >
                    了解万能表单
                  </a>
                </div>
              </template>
              <span
                v-else
                class="name"
              > -->
              <span class="name">
                {{ item.name }}
              </span>
              <!-- </span> -->
            </template>
            <i
              v-if="item.child"
              class="iconfont fr arrow mr-16"
              :class="{'iconicon-test19': !item.open, 'iconicon-test18': item.open}"
            />
          </div>
          <ul
            v-show="item.open"
            class="childs"
            :class="{'show': item.open}"
          >
            <template v-for="(child, j) in item.child">
              <li
                v-if="child.show"
                :key="j"
                class="child"
                :class="{ 'active': child.active }"
                @click="handleChangeMenuChild(item, child)"
              >
                <span class="name">{{ child.name }}</span>
              </li>
            </template>
          </ul>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
// import Cookies from 'js-cookie'

export default {
  components: {
  },
  data () {
    return {
      cookie: ''
    }
  },
  computed: {
    ...mapState(['menuDatas', 'baseinfo', 'roleDefault']),
    pid () {
      return this.$store.state.pid || this.$route.params.pid
    },
    routeName () {
      return this.$route.name
    },
    routeMeta () {
      return this.$route.meta
    },
    from () {
      return this.$route.query.from || 'all'
    },
    type () {
      return this.$route.query.type || 'inquiry-all'
    },
    peroid () {
      return this.$route.query.period || 'index'
    },
    menuLabels () {
      return this.menuDatas.menuLabels
    },
    permissionMenuList () {
      return this.menuDatas.permissionMenuList
    },
    menuList () {
      let res = []
      for (let one of this.menuLabels) {
        let parent = JSON.parse(JSON.stringify(one))
        for (let j in this.permissionMenuList) {
          if (parent.key === j) {
            const item = this.permissionMenuList[j]
            parent.state = item.state
            parent.show = parent.state
            if (parent.key === 'cost-maintenance') {
              if (parent.state && this.baseinfo.vip) {
                parent.show = true
              } else {
                parent.show = false
              }
            }
            /* else if (parent.key === 'statistics') {
              // 如果是付费用户，展示『数据统计』主菜单
              // 如果是免费用户、当前用户有信息开发权限，展示『数据统计』主菜单
              const inquiryMine = this.menuLabels['inquiry-mine'] || {}
              const inquiryMineChild = inquiryMine.child || {}
              const inquiryDev = inquiryMineChild['inquiry-dev'] || {}
              let isDev = inquiryDev.state
              if (parent.state && (this.baseinfo.vip === 1 || isDev)) {
                parent.show = true
              } else {
                parent.show = false
              }
            } */

            if (item.child) {
              parent.child = []
              for (let c in item.child) {
                let state = item.child[c].state
                let show = state
                /* if (c === 'statistics-all' || c === 'statistics-dev' || c === 'statistics-followup') {
                  if (state && this.baseinfo.vip) {
                    show = true
                  } else {
                    show = false
                  }
                } */
                parent.child.push({
                  key: c,
                  name: item.child[c].name,
                  active: false,
                  show
                })
              }
            }
          }
        }
        res.push(parent)
      }
      let groupClass
      res.forEach(item => {
        let currentClass = item.group
        if (groupClass !== item.group) {
          item.group += ` first`
        }
        groupClass = currentClass
      })

      return res
    }
  },
  watch: {
    $route (to, from) {
      this.setDefault()
    },
    menuList: {
      handler (val) {
        this.setDefault()
      },
      immediate: true
    }
  },
  async created () {
    !this.roleDefault && await this.permissionMenu()
    // this.cookie = Cookies.get('old')
  },
  mounted () {
    this.setRoleDefault(false)
  },
  methods: {
    ...mapActions(['permissionMenu']),
    ...mapMutations(['setRoleDefault']),
    handleChangeMenu (item, ev) {
      for (let one of this.menuList) {
        this.$set(one, 'active', false)
        if (one.key !== item.key) {
          this.$set(one, 'open', false)
        }
        if (!item.child && one.child && one.key !== item.key) {
          for (let child of one.child) {
            this.$set(child, 'active', false)
          }
        }
      }
      this.$set(item, 'active', true)
      if (item.child) {
        this.$set(item, 'open', !item.open)
      }
      this.$forceUpdate()

      // 设置路由跳转
      let query = {}
      if (item.child) {
        // 如果点击的是我的信息或全部信息的父级菜单，不跳转页面
        if (ev.target.className.indexOf('child') === -1) return

        query = {
          type: this.type,
          all: item.key === 'inquiry-all' ? 1 : 0
        }
      }
      this.$router.push({
        path: `/project/${this.pid}/${item.link}`,
        query
      })
    },
    handleChangeMenuChild (item, child) {
      for (let parent of this.menuList) {
        this.$set(parent, 'active', false)
        for (let key in parent.child) {
          const myChild = parent.child[key]
          this.$set(myChild, 'active', false)
        }
      }
      for (let one of item.child) {
        if (one.key === child.key) {
          this.$set(one, 'active', true)
        }
      }
      this.$forceUpdate()
      // 设置路由跳转
      let query = {}
      if (item.child) {
        query.type = child.key
      }
      if (item.key === 'inquiry-all') {
        query.from = 'all'
      } else if (item.key === 'inquiry-mine') {
        query.from = 'my'
      } else if (item.key === 'inquiry-audit') {
        query.from = 'audit'
      } else if (item.key === 'statistics') {
        query.type = child.key
        if (child.key === 'statistics-dev') {
          this.$router.push({
            path: `/project/${this.pid}/data/statistic/develop`,
            query
          })
        } else if (child.key === 'statistics-rec') {
          query.recType = 'createSta'
          this.$router.push({
            path: `/project/${this.pid}/data/statistic/reception`,
            query
          })
        } else if (child.key === 'statistics-all') {
          this.$router.push({
            path: `/project/${this.pid}/data/statistic`,
            query
          })
        } else if (child.key === 'statistics-followup') {
          this.$router.push({
            path: `/project/${this.pid}/data/statistic/follow`,
            query
          })
        }
        return
      }
      this.$router.push({
        path: `/project/${this.pid}/${item.link}`,
        query
      })
    },
    setDefault () {
      for (let i in this.menuList) {
        const parent = this.menuList[i]
        this.$set(parent, 'active', false)
        this.$set(parent, 'open', false)

        let routeName = this.routeName
        if (routeName === 'InqueryDetail') {
          if (this.from === 'all' || this.from === 'my') {
            routeName = 'InqueryList'
          } else if (this.from === 'audit') {
            routeName = 'InqueryAudit'
          }
          // 补充。。。
        }

        if (parent.key === 'statistics') {
          this.setChildDefault(parent, i)
          this.$forceUpdate()
        }

        if (parent.key === 'cost-maintenance') {
          if (this.peroid !== 'index') {
            this.$set(parent, 'active', true)
            this.$forceUpdate()
          }
        }
        if (parent.key === 'email-direct-marketing' && (this.routeName === 'DetailedList' ||
        this.routeName === 'SendReport' || this.routeName === 'EditContactList' || this.routeName === 'EdmEmailEdit' || this.routeName === 'EdmEmailPrivew')) {
          this.$set(parent, 'active', true)
          this.$forceUpdate()
        }

        if (parent.key === 'project-config' && this.routeMeta.menuKey === 'project-config') {
          this.$set(parent, 'active', true)
          this.$forceUpdate()
        }
        // 线索管理录入线索和线索详情
        if (parent.key === 'clue-all') {
          if (this.routeName === 'ClueCreate' || this.routeName === 'ClueDetail') {
            this.$set(parent, 'active', true)
            this.$forceUpdate()
          }
        }

        if (routeName !== parent.routeName) continue

        if (parent.child || routeName === 'InqueryDetail') {
          // 默认链接定位到子菜单
          if (this.from === 'all' && parent.key === 'inquiry-all') {
            this.setChildDefault(parent, i)
          } else if (this.from === 'my' && parent.key === 'inquiry-mine') {
            this.setChildDefault(parent, i)
          } else if (this.from === 'audit' && parent.key === 'inquiry-audit') {
            this.setChildDefault(parent, i)
          }
          // 补充。。。
        } else {
          // 默认链接定位到父菜单
          this.$set(parent, 'active', true)
          this.setChildDefault(parent, i)
        }
      }
      this.$forceUpdate()
    },
    setChildDefault (parent, i) {
      if (!parent.child) return
      for (let j in parent.child) {
        const child = parent.child[j]
        this.$set(child, 'active', false)
        if (child.key === this.type) {
          this.$set(parent, 'open', true)
          this.$set(child, 'active', true)
        }
      }
      // this.$forceUpdate()
    },
    setClass (item) {
      let obj = {
        active: item.active && !item.child
      }
      obj[item.group] = true
      return obj
    }
  }
}
</script>

<style lang="scss" scoped>
.nav {
  width: 160px;
  height: 100%;
  padding: 16px 0;
  background-color: #fff;
  li {
    position: relative;
    .item,
    .child {
      height: 40px;
      line-height: 40px;
      padding: 0px 0px 0px 24px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      border-right: solid 2px #fff;

      &:hover {
        color: $primary-color;
        background-color: #f7f7f7;
        .left-icon {
          color: $primary-color;
        }
      }
    }
    .item {
      & > .iconfont {
        margin-right: 10px;
        color: #d6d6d6;
        font-size: 16px;
      }
      .left-icon {
        position: relative;
        top: 1px;
        margin-right: 8px;
      }
    }

    &.active > .item,
    &.active.child {
      position: relative;
      z-index: 1000;
      color: $primary-color;
      background-color: #f4f7f9;
      font-weight: 600;
      border-right: solid 2px $primary-color;
      .name {
        font-weight: 600;
      }
      .left-icon {
        color: $primary-color;
      }
    }
    .child {
      color: #808080;
      font-weight: 600;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      .name {
        padding-left: 26px;
      }
      & > .iconfont {
        color: #d6d6d6;
        font-size: 12px;
      }
    }
  }
  li.first {
    margin-top: 16px;
    &:first-child {
      margin: 0;
    }
  }
  /* .group1:last-child,
  .group2:last-child,
  .group3:last-child,
  .group4:last-child {
    margin-bottom: 16px;
  } */
}
.tip-dialog {
  background:#DEEAFA url(../../assets/images/imgicobg.png) no-repeat 450px bottom;
  height: 138px;
  width: 570px;
  border-radius: 4px;
  box-shadow:0px 1px 4px 0px rgba(80,119,170,0.2),0px -2px 4px 0px rgba(80,119,170,0.08);
  position: absolute;
  right: -600px;
  top: -50px;
  padding: 32px 16px 32px 32px;
  z-index: 2222;
   p{
     font-size: 20px;
     font-weight: bold;
     color: #000;
   }
  .ioc-arrow {
    position: absolute;
    left: -10px;
    top: 46%;
    width:0;
    height:0;
    border-top:10px solid transparent;
    border-bottom:10px solid transparent;
    border-right:10px solid #DEEAFA;
  }
  .close {
    position: absolute;
    right: 16px;
    top: 8px;
    font-size: 16px;
    color: #999;
    cursor: pointer;
  }
}
.universal-tit-box {
  font-style: normal;
  i{
    background: url(../../assets/images/newico.png) no-repeat 0 0;
    width: 40px;
    height: 23px;
    display: inline-block;
    vertical-align: middle;
    background-size: 40px 23px;
  }
}
</style>
